function sliderInit(openerQuery, sliderQuery) {
	const slider = $(sliderQuery);
	const togglers = $(`${openerQuery}, ${sliderQuery} .slideout-close`);

	const inner = $(`${sliderQuery} > .slideout--inner`);

	function close() {
		document.body.classList.remove("no-scroll");

		slider.removeClass("fade-in");
		inner.removeClass("open-inner");
		inner.one("transitionend", function () {
			slider.removeClass("open");
		});
	}

	function toggle() {
		document.body.classList.add("no-scroll");
		if (slider.hasClass("open")) {
			close();
			return;
		}
		if (!slider.hasClass("slideout--outer")) {
			slider.addClass("slideout--outer");
		}
		slider.addClass("open");
		slider.addClass("fade-in");
		inner.addClass("open-inner");
	}

	/* Opener */
	togglers.click(function (event) {
		event.stopPropagation();
		toggle();
		
	});

	/* Wrapper click listener */
	slider.click(function (event) {
		if (!$(event.target).is(slider)) return;
		close();
	});
}
